import { render, staticRenderFns } from "./SubjectAdd.vue?vue&type=template&id=48f2a4b6&scoped=true"
import script from "./SubjectAdd.vue?vue&type=script&lang=js"
export * from "./SubjectAdd.vue?vue&type=script&lang=js"
import style0 from "./SubjectAdd.vue?vue&type=style&index=0&id=48f2a4b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f2a4b6",
  null
  
)

export default component.exports